import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiProfessional: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_17040)">
                <path
                    d="M6.00023 11.7602C2.82419 11.7602 0.240234 9.17627 0.240234 6.00023C0.240234 2.82419 2.82419 0.240234 6.00023 0.240234C9.17627 0.240234 11.7602 2.82419 11.7602 6.00023C11.7602 9.17627 9.17627 11.7602 6.00023 11.7602ZM6.00023 0.960234C3.22115 0.960234 0.960234 3.22115 0.960234 6.00023C0.960234 8.77931 3.22115 11.0402 6.00023 11.0402C8.77931 11.0402 11.0402 8.77931 11.0402 6.00023C11.0402 3.22115 8.77931 0.960234 6.00023 0.960234ZM7.80023 5.28023C7.40315 5.28023 7.08023 4.95731 7.08023 4.56023C7.08023 4.16315 7.40315 3.84023 7.80023 3.84023C8.19731 3.84023 8.52023 4.16315 8.52023 4.56023C8.52023 4.95731 8.19731 5.28023 7.80023 5.28023ZM4.20023 5.28023C3.80315 5.28023 3.48023 4.95731 3.48023 4.56023C3.48023 4.16315 3.80315 3.84023 4.20023 3.84023C4.59731 3.84023 4.92023 4.16315 4.92023 4.56023C4.92023 4.95731 4.59731 5.28023 4.20023 5.28023ZM8.52023 7.80023C8.52023 7.60139 8.35907 7.44023 8.16023 7.44023H3.84023C3.64139 7.44023 3.48023 7.60139 3.48023 7.80023C3.48023 7.99907 3.64139 8.16023 3.84023 8.16023H8.16023C8.35907 8.16023 8.52023 7.99907 8.52023 7.80023Z"
                    fill="#1208A5"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_17040">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiProfessional;
